<script setup lang="ts">
import Footer from "~/components/structure/Footer.vue";
import NavBar from "~/components/structure/NavBar.vue";
import { useAuthClient } from "~/lib/auth-client";

// Auth logic
const { getUserInfo, isAuthenticated } = useAuthClient();
const userInfo = ref<any>(null);

// Check authentication and fetch user info in layout
onBeforeMount(async () => {
  if (isAuthenticated) {
    try {
      userInfo.value = await getUserInfo();
    } catch (error) {
      console.error("Failed to fetch user info", error);
    }
  }
});

// Provide `userInfo` to all descendants
provide("userInfo", userInfo);
</script>

<template>
  <NavBar layout="corporate" />

  <v-main>
    <slot />
  </v-main>

  <Footer />
</template>
